// @flow

import * as React from 'react';
import { Icon } from '@ta/styleguide.icon';
import classNames from '@ta/common.classnames';

import styles from './AddFriendIcon.less';

type IconSize = 'small' | 'default' | 'large' | 'xtra-large';

type AddFriendProps = {|
  size?: IconSize,
  tabletSize?: IconSize,
  /** Click handler for avatar */
  onClick?: () => mixed,
  targetRef: (?HTMLElement) => void,
|};

/**
 * Renders the add friend icon in all available avatar sizes
 */
const AddFriendIcon = (props: AddFriendProps) => {
  const sizeClass = props.size || 'default';
  const desktopClass = props.tabletSize ? `${props.tabletSize || 'default'}-tablet` : null;

  return (
    <span
      onClick={props.onClick}
      ref={props.targetRef}
      className={classNames(styles.addFriendsIcon, 'ui_social_avatar', sizeClass, desktopClass)}
    >
      <Icon name="plus" />
    </span>
  );
};

AddFriendIcon.defaultProps = {
  size: 'default',
  tabletSize: undefined,
  onClick: undefined,
};

export default AddFriendIcon;
